import classNames from 'classnames'
import toast from 'cogo-toast'
import { RemoveUserElementType } from 'globalTypes'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'
import { Trans, t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import RemoveElementPageProfile from 'Root/App/Card/RemoveElementPageProfile'

import styles from './index.module.css'

library.add(faCircleXmark)

const RemovePageProfile = ({ id, typename }) => {
  const { i18n } = useLingui()

  const onRemoveCallback = () =>
    toast.warn(
      <div className="flex flex-col gap-3">
        <div>{t(i18n)`Elemento rimosso.`}</div>
      </div>
    )

  return (
    <Menu.Item>
      {({ active, ...props }) => (
        <RemoveElementPageProfile
          {...props}
          className={classNames(
            active ? styles.active : styles.notActive,
            styles.item
          )}
          elementId={id}
          elementTypename={typename}
          type={RemoveUserElementType.content}
          value={false}
          callback={onRemoveCallback}
        >
          <FontAwesomeIcon
            className={styles.icon}
            icon={['fas', 'circle-xmark']}
          />
          <Trans>Rimuovi dal profilo</Trans>
        </RemoveElementPageProfile>
      )}
    </Menu.Item>
  )
}

export default RemovePageProfile
